import { getShopPackageSetting } from "../services/retail/setting/retailSettingService";
import { BOOKING_PLATFORM } from "../utils/constant";
import { getSettingsActiveFeatures } from "../services/api/retail/merchantInfoApi";
import {
  setIsOpenNotiEndSubscription,
  setIsShopInactive,
  setIsShopUpgradePackageSucce,
  setIsShowAlertEndSubscription,
  setShopInfo,
} from "../store/slices/shopSlice";
import {
  OnboardingFeature,
  setOnboardingSettings,
} from "../store/slices/onboardingFeatureSlice";
import { useRouter } from "../utils/hooks/useRouter";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../store/hooks";
import { useLocation } from "react-router-dom";
import { BRAND_TYPE_KEIVI } from "../services/retail/setting/package_shop_name";

const useMerchantPackage = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const onboardingFeatureInfo = useAppSelector(OnboardingFeature);
  const location = useLocation();
  const getShopPackage = async (merchantInfo: IRetailMerchantInfo) => {
    if (merchantInfo?.ref_id && !location.pathname.includes("admin-merchant")) {
      const request = [
        getShopPackageSetting({
          merchant_id: merchantInfo.ref_id,
          from: "iframe",
          platform: router.query.platform || "retail",
          isKeivi: typeof merchantInfo?.brand_type && merchantInfo?.brand_type === BRAND_TYPE_KEIVI
        }),
      ];
      if (
        router.query.platform === "retail" ||
        router.query.platform === BOOKING_PLATFORM ||
        router.query.platform
      ) {
        request.push(
          getSettingsActiveFeatures(router.query.platform || "retail")
        );
      }
      try {
        const [responseShop, responseFeatureActive] = await Promise.all(
          request
        );
        if (responseShop.data.isShopEndOfSubscription) {
          dispatch(
            setIsOpenNotiEndSubscription({
              value: responseShop.data.isShopEndOfSubscription,
            })
          );
        }
        dispatch(
          setIsShopInactive({
            value: responseShop.data.isShopInactive,
          })
        );
        dispatch(
          setShopInfo({
            shop: responseShop.data,
            isOpenNotiEndSubscription:
              responseShop.data.isShopEndOfSubscription,
            isShopInactive: responseShop.data.isShopInactive,
            isShowAlertEndSubscription:
              responseShop.data.isShowAlertEndSubscription,
            isShopUpgradePackageSuccess: responseShop.data.isShopUpgradeSuccess,
          })
        );
        dispatch(
          setIsShowAlertEndSubscription({
            value: responseShop.data.isShowAlertEndSubscription,
          })
        );
        dispatch(
          setIsShopUpgradePackageSucce({
            value: responseShop.data.isShopUpgradePackageSuccess,
          })
        );
        dispatch(
          setOnboardingSettings({
            value: {
              ...onboardingFeatureInfo,
              ...responseFeatureActive,
            },
          })
        );
      } catch (error) {
        console.log({ error });
      }
    }
  };

  return {
    getShopPackage,
  };
};

export default useMerchantPackage;
